/* GET LEAD_REFUNDS */
export const GET_ADMIN_LEAD_REFUNDS = "GET_ADMIN_LEAD_REFUNDS"
export const GET_ADMIN_LEAD_REFUNDS_SUCCESS = "GET_ADMIN_LEAD_REFUNDS_SUCCESS"
export const GET_ADMIN_LEAD_REFUNDS_ERROR = "GET_ADMIN_LEAD_REFUNDS_ERROR"

/* UPDATE LEAD_REFUNDS */
export const UPDATE_ADMIN_LEAD_REFUND = "UPDATE_ADMIN_LEAD_REFUND"
export const UPDATE_ADMIN_LEAD_REFUND_SUCCESS = "UPDATE_ADMIN_LEAD_REFUND_SUCCESS"
export const UPDATE_ADMIN_LEAD_REFUND_ERROR = "UPDATE_ADMIN_LEAD_REFUND_ERROR"

/* UPDATE LEAD_REFUNDS */
export const DELETE_ADMIN_LEAD_REFUND = "DELETE_ADMIN_LEAD_REFUND"
export const DELETE_ADMIN_LEAD_REFUND_SUCCESS = "DELETE_ADMIN_LEAD_REFUND_SUCCESS"
export const DELETE_ADMIN_LEAD_REFUND_ERROR = "DELETE_ADMIN_LEAD_REFUND_ERROR"
